module.exports = __webpack_public_path__ + "img/settings.59b5495f.svg";